import { Box, Paper, Tab } from '@mui/material';
import React, { useMemo } from 'react';
import Tabla from '../../../components/ui/materialui/tabla';
import { useColumns } from '../utils/columnsGenerarDiv';
import { GenerarDivRow } from '../models/dividendos';
import TableHeader from '../../../components/ui/materialui/tableHeader';
import MButton from '../../../components/inputs/yup/materialui/mButton';
import { exportExcel } from '../../../utils/exportExcel';
import { SummarizeTwoTone } from '@mui/icons-material';

interface IProps {
    data: GenerarDivRow[];
}

const TablaGenerarDiv: React.FC<IProps> = ({ data }) => {

    const { COLUMNS } = useColumns();
    const columns = useMemo(() => COLUMNS, []);

    return (
        <Box sx={{ mt: 2 }}>
            <Tabla
                columns={columns}
                data={data}
                // titulo={
                //     <TableHeader
                //         buttonExport={
                //             <MButton
                //                 type="button"
                //                 variant="outlined"
                //                 onClick={() => exportExcel(data, columns, "DIVIDENDOS")}
                //                 startIcon={<SummarizeTwoTone />}
                //             >
                //                 Exportar
                //             </MButton>
                //         }
                //     />
                // }
            />
        </Box>
    );
};

export default TablaGenerarDiv;